import React from 'react'
import { Link } from 'react-router-dom'

export default function Products() {
    return (
        <>
            <div id='product'>
                <h5 style={{ "marginBottom": "1rem", "color": "orange" }}>EXPLORE THE AWESOME</h5>
                <h1 style={{ "marginBottom": "3rem", "fontSize": "3rem","textAlign":"center" }}>Various Products</h1>
                <div className='prod'>
                    <Link to="/prod" style={{ "textDecoration": "none", "color": "black" }} onClick={() => {
                        window.scroll({
                            top: 0,
                             behavior:"instant"
                        });
                    }}>
                        <div  data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500" className='prod1'>
                            <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/disp.jpg" alt="" />
                            <p>1. Curtain finials.</p>
                        </div>
                    </Link>
                    <Link to="/prod2" style={{ "textDecoration": "none", "color": "black" }} onClick={() => {
                        window.scroll({
                            top: 0,
                             behavior:"instant"
                        });
                    }}>
                        <div className='prod1' data-aos-delay="100" data-aos-duration="1500" data-aos="fade-up">
                            <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/disp1.jpg" alt="" />
                            <p>2. Curtain Channels</p>
                        </div>
                    </Link>
                    <Link to="/prod3" style={{ "textDecoration": "none", "color": "black" }} onClick={() => {
                        window.scroll({
                            top: 0,
                             behavior:"instant"
                        });
                    }}>
                        <div className='prod1' data-aos-delay="100" data-aos-duration="1500" data-aos="fade-down" >
                            <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/WhatsApp%20Image%202023-01-16%20at%2022.13.18.jpg" alt="" />
                            <p>3. Window Blinds</p>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    )
}
